
  import { computed, defineComponent } from 'vue'
  import { useMainStore } from '@/shared/store'

  export default defineComponent({
    setup() {
      const store = useMainStore()
      return {
        error: computed(() => store.error),
        clearError: store.clearError,
      }
    },
  })
